import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-black text-background border-t-2 border-black overflow-hidden">
      <div className="px-6 sm:px-12 lg:px-20 py-16 sm:py-24">
        <p aria-hidden className="font-display uppercase text-[18vw] leading-[0.8] text-outline-paper select-none whitespace-nowrap">
          Stay Loud
        </p>
        <div className="mt-14 grid gap-10 sm:grid-cols-3 font-mono text-sm">
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-primary font-bold mb-4">Shop</p>
            <ul className="space-y-2">
              <li><Link to="/shop" data-testid="footer-shop-all" className="hover:text-accent transition-colors">All Products</Link></li>
              <li><Link to="/shop?type=tee" data-testid="footer-shop-tees" className="hover:text-accent transition-colors">Heavy Tees</Link></li>
              <li><Link to="/shop?type=womens-tee" data-testid="footer-shop-womens" className="hover:text-accent transition-colors">Women's Tees</Link></li>
              <li><Link to="/shop?type=hoodie" data-testid="footer-shop-hoodies" className="hover:text-accent transition-colors">Hoodies</Link></li>
              <li><Link to="/shop?type=baby-tee" data-testid="footer-shop-baby" className="hover:text-accent transition-colors">Baby Tees</Link></li>
              <li><Link to="/about" data-testid="footer-about" className="hover:text-accent transition-colors">Our Story</Link></li>
              <li><Link to="/faq" data-testid="footer-faq" className="hover:text-accent transition-colors">FAQ</Link></li>
              <li><Link to="/faq" data-testid="footer-shipping-returns" className="hover:text-accent transition-colors">Shipping & Returns</Link></li>
              <li><Link to="/track" data-testid="footer-track-order" className="hover:text-accent transition-colors">Track Your Order</Link></li>
            </ul>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-primary font-bold mb-4">The Fine Print</p>
            <p className="text-white/60 leading-relaxed">
              Satire is protected speech. Cotton is not affiliated with any movement — it just absorbs everything.
              Every order is printed to order and really shipped to your door.
            </p>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-primary font-bold mb-4">Contact</p>
            <p className="text-white/60 leading-relaxed">
              <a href="mailto:yell@fleecetheregime.com" data-testid="footer-email-link" className="underline underline-offset-2 hover:text-primary transition-colors">
                yell@fleecetheregime.com
              </a>
              <br />
              <a href="https://www.etsy.com/shop/FleeceTheRegime" target="_blank" rel="noopener noreferrer" data-testid="footer-etsy-link" className="underline underline-offset-2 hover:text-primary transition-colors">
                Also on Etsy → FleeceTheRegime
              </a>
              <br />
              Printed and shipped from somewhere with due process.
            </p>
          </div>
        </div>
        <div className="mt-14 pt-6 border-t border-white/20 flex flex-wrap justify-between items-center gap-4 font-mono text-xs text-white/40 uppercase tracking-widest">
          <span className="flex items-center gap-3">
            <img src="/logo.png" alt="Fleece The Regime ram logo" className="h-9 w-9 object-contain border-2 border-white/30 bg-background" data-testid="footer-logo" />
            © 2026 Fleece The Regime™
          </span>
          <Link to="/terms" data-testid="footer-terms-link" className="hover:text-accent transition-colors">Terms & IP</Link>
          <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-accent transition-colors">Privacy</Link>
          <span>Made with rage & ring-spun cotton</span>
        </div>
      </div>
    </footer>
  );
}
